import React, {useEffect, useRef, useState} from 'react';
import {useLocation, useNavigate} from "react-router-dom";
import {
    createCountry,
    createLanguage,
    editCountry,
    editLanguage,
    getCountriesDetail,
    getLanguagesDetail
} from "../../../API/helper";
import {ProgressSpinner} from "primereact/progressspinner";
import Header from "../../../components/header/Header";
import {InputText} from "primereact/inputtext";
import {Button} from "primereact/button";
import {Toast} from "primereact/toast";
import {Dialog} from "primereact/dialog";
import Lottie from "react-lottie-player";
import settingsAnimation from "../../../assets/settingsAnimation.json";

function LanguageDetail(props) {
    const { state } = useLocation();
    const toast = useRef(null);
    const [visible, setVisible] = useState(false);
    const [label,setLabel]=useState("")
    const [loading,setLoading]=useState(false)
    const [languageValue, setLanguageValue] = useState({});
    const navigate = useNavigate();
    const getLanguages = async ()=>{
        setLoading(true)
        await getLanguagesDetail(state.id).then((res)=>{
            setLanguageValue(res.data.list)
            setLoading(false)
        })
    }
    const createNewLanguage = async () => {
        await createLanguage(languageValue).then((response) =>{
                if(response.success){
                    toast.current.show({
                        severity: "success",
                        summary: "Successful",
                        detail: response.message,
                        life: 3000,
                    })
                    setTimeout(() => {
                        navigate("/languages")
                    }, 1000);
                }
                else{
                    toast.current.show({
                        severity: "error",
                        summary: "Error",
                        detail: response.message,
                        life: 3000,
                    })
                }

            }

        );
    };
    const editLanguageData = async (admin_id) => {
        await editLanguage(languageValue,admin_id).then((response) =>{
                if(response.success){
                    toast.current.show({
                        severity: "success",
                        summary: "Successful",
                        detail: response.message,
                        life: 3000,
                    })
                    setTimeout(() => {
                        navigate("/languages")
                    }, 1000);
                }
                else{
                    toast.current.show({
                        severity: "error",
                        summary: "Error",
                        detail: response.message,
                        life: 3000,
                    })
                }

            }

        );
    };

    const onSubmit = ()=>{
        if(state?.create){
            createNewLanguage()
        }else{
            editLanguageData(state?.id)
        }
    }
    useEffect(()=>{
        if(!state?.create){
            setLabel("Language Details")
            getLanguages()
        }else{
            setLabel("Create New Language")
        }
    },[])
    return (
        <div>
            {loading ? (
                <div className="settings-loader">
                    <Lottie
                        loop
                        animationData={settingsAnimation}
                        play
                        style={{ width: 400, height: 400 }}
                    />
                </div>
            ) :  <div>
                <Header items={[{ label: 'Languages' , url: '/languages'},{ label: label }]} />
                <div style={{padding:20,display:"flex",gap:20,backgroundColor:"#f8f9fa",border:"1px solid #dee2e6",margin:10}}>
                    <div>
                        <div className="admin-wrapper">
                            <div className="admin-info-wrapper">
                                <span>Code:</span>
                                <InputText value={languageValue.code} onChange={(e) => setLanguageValue({...languageValue,code:e.target.value})} />
                            </div>
                            <div className="admin-info-wrapper">
                                <span>Title:</span>
                                <InputText value={languageValue.title} onChange={(e) => setLanguageValue({...languageValue,title:e.target.value})} />
                            </div>
                            <div className="admin-info-wrapper">
                                <span>NLP URL:</span>
                                <InputText value={languageValue.nlp_url} onChange={(e) => setLanguageValue({...languageValue,nlp_url:e.target.value})} />
                            </div>

                        </div>
                    </div>
                </div>
                <div style={{display:"flex",paddingRight:20,justifyContent:"flex-end",marginBottom:20}}>
                    <Button className="p-button-info"
                            onClick={()=>{onSubmit()
                            }}>{state?.create ? "Create New Language":"Edit Language Data"}</Button>
                </div>
                <div className="datatable-crud-demo">
                    <Toast ref={toast} />
                    <Dialog header="Chat Messages" visible={visible} draggable={false} blockScroll style={{ width: '40vw',marginLeft:50 }} onHide={() => setVisible(false)}>
                    </Dialog>
                </div>
            </div>}
        </div>

    )
}

export default LanguageDetail;